// VW · Recent sale toast (bottom-left)
// Illustrative/simulated rotation — picks a random real product (title,
// url, image) from the store catalogue via the JSON blob rendered by
// snippets/vw-recent-sale-toast.liquid, paired with a randomised buyer
// first name, UK town, and a "time ago" between 28 minutes and 12 hours.
// Not a live order feed. Swap the data source here if real order data
// is wanted later.
(function () {
  var NAMES = ['Sarah', 'Jamie', 'Chloe', 'Marcus', 'Aisha', 'Ben', 'Sophie', 'Tom', 'Ellie', 'Ryan'];
  var TOWNS = ['Manchester', 'Leeds', 'Birmingham', 'Glasgow', 'Bristol', 'Cardiff', 'Liverpool', 'Nottingham', 'Sheffield', 'Coventry'];

  var MIN_DELAY_MS = 18000;
  var MAX_DELAY_MS = 40000;
  var VISIBLE_MS = 5500;

  var MIN_AGO_MINUTES = 28;
  var MAX_AGO_MINUTES = 12 * 60; // 12 hours

  function pick(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
  }

  function randomDelay() {
    return MIN_DELAY_MS + Math.random() * (MAX_DELAY_MS - MIN_DELAY_MS);
  }

  function randomTimeAgo() {
    var totalMinutes = Math.floor(MIN_AGO_MINUTES + Math.random() * (MAX_AGO_MINUTES - MIN_AGO_MINUTES + 1));

    if (totalMinutes < 60) {
      return totalMinutes + ' minutes ago';
    }

    var hours = Math.floor(totalMinutes / 60);
    var minutes = totalMinutes % 60;

    if (minutes === 0) {
      return hours + (hours === 1 ? ' hour ago' : ' hours ago');
    }

    return hours + 'h ' + minutes + 'm ago';
  }

  function loadProducts(toast) {
    var dataEl = document.getElementById('vw-recent-sale-toast-data');
    var products = [];

    if (dataEl) {
      try {
        products = JSON.parse(dataEl.textContent) || [];
      } catch (e) {
        products = [];
      }
    }

    // Filter out any entries missing an image, then fall back to the
    // current product if the catalogue list came back empty.
    products = products.filter(function (p) {
      return p && p.title && p.image;
    });

    if (products.length === 0) {
      var fallbackTitle = toast.dataset.productTitle || 'this bundle';
      products = [{ title: fallbackTitle, url: '', image: '' }];
    }

    return products;
  }

  function init() {
    var toast = document.getElementById('vw-recent-sale-toast');
    if (!toast) return;

    var textEl = toast.querySelector('.vw-rs-toast__text');
    var imgEl = toast.querySelector('.vw-rs-toast__img');
    var closeBtn = toast.querySelector('.vw-rs-toast__close');
    var products = loadProducts(toast);
    var dismissedThisSession = false;
    var timer = null;

    function showToast() {
      if (dismissedThisSession || document.hidden) {
        scheduleNext();
        return;
      }

      var name = pick(NAMES);
      var town = pick(TOWNS);
      var timeAgo = randomTimeAgo();
      var chosenProduct = pick(products);

      if (imgEl) {
        imgEl.src = chosenProduct.image || '';
        imgEl.alt = chosenProduct.title || '';
      }

      textEl.innerHTML =
        '<strong>' + name + '</strong> from ' + town + ' bought <strong>' + chosenProduct.title + '</strong> \u2014 ' + timeAgo;

      toast.hidden = false;
      requestAnimationFrame(function () {
        toast.setAttribute('data-visible', 'true');
      });

      window.setTimeout(hideToast, VISIBLE_MS);
    }

    function hideToast() {
      toast.setAttribute('data-visible', 'false');
      window.setTimeout(function () {
        toast.hidden = true;
      }, 400);
      scheduleNext();
    }

    function scheduleNext() {
      window.clearTimeout(timer);
      timer = window.setTimeout(showToast, randomDelay());
    }

    closeBtn.addEventListener('click', function () {
      dismissedThisSession = true;
      hideToast();
    });

    // First appearance after a short initial delay so it doesn't fire instantly on page load
    timer = window.setTimeout(showToast, 6000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
